<div class="row col-12 no-gutters">
  <div class="top_nav ml-auto justify-content-end">
    <ul class="d-sm-flex align-items-center d-none">
      <li class="padding-layout-nav-top menu-item" style="cursor: pointer !important;">
        <div class="d-flex align-items-center text-white">
          <span class="material-icons">
            view_headline
          </span>
          <span class="ml-1">Menu</span>
        </div>
        <div class="menu-container justify-content-end">
          <div class="menu w-100">
            <div class="col-6 px-0 darkBlue" style="height: 100%;">
              <div class="row m-0">
                <div class="col-12 px-0 darkBlue portal">
                  <span class="col-12 py-1 pl-3 " style="font-size: 14px; line-height: 32px;">
                    <a href="/" style="color: black;">REN Supplier Portal</a>
                  </span>
                  <hr style="background-color: white;" class="m-0">
                  <div class="lightBlue sub-item">
                    <div class="px-3 py-1">
                      <ul class="d-flex flex-column">
                        <li class="" *ngFor="let item of menuPortal; let i = index;">
                          <!-- <a *ngIf="i === 3 && (isRSP || i === 0)" (click)="goPageWiki()" class="url-item"
                                                        style="cursor: pointer; color: black;" >{{item.name}}</a> -->
                          <a *ngIf="i !== 3 && (isRSP || i === 0)"
                            [href]="userName ? item.url : redirectTo(item.redirectTo)" class="url-item"
                            style="color: black;">{{item.name}}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row m-0">
                <div class="col-12 px-0 darkBlue portal" *ngIf="!userName || userName && isSRM">
                  <span class="col-12 py-1 pl-3 " style="font-size: 14px; line-height: 32px;">
                    <a href="/srm" style="color: black;">SRM</a>
                  </span>
                  <hr style="background-color: white;" class="m-0">
                  <div class="lightBlue sub-item">
                    <div class="px-3 py-1">
                      <ul class="d-flex flex-column" *ngIf="!userName">
                        <li>
                          <a href="/login?redirectTo=SRM" style="color: black;">Sign-In</a>
                        </li>
                      </ul>
                      <ul class="d-flex flex-column" *ngIf="isSRM">
                        <li *ngFor="let item of srmMenu" [hidden]="checkHidden(item.permissions)">
                          <a [routerLink]="item.url" class="url-item" style="color: black;">
                            {{item.name}}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row m-0">
                <div class="col-12 px-0 darkBlue portal" *ngIf="!userName || userName && isContract">
                  <span class="col-12 py-1 pl-3 " style="font-size: 14px; line-height: 32px;">
                    <a href="/contracts" style="color: black;">Contract Management</a>
                  </span>
                  <hr style="background-color: white;" class="m-0">
                  <div class="lightBlue sub-item">
                    <div class="px-3 py-1">
                      <ul class="d-flex flex-column" *ngIf="!userName">
                        <li>
                          <a href="/login?redirectTo=CONTRACTS" style="color: black;">Sign-In</a>
                        </li>
                      </ul>
                      <ul class="d-flex flex-column" *ngIf="isContract">
                        <li *ngFor="let item of contractMenu" [hidden]="checkHidden(item.permissions)">
                          <a [routerLink]="item.url" class="url-item" style="color: black;">
                            {{item.name}}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row m-0">
                <div class="col-12 px-0 darkBlue portal" *ngIf="!userName || userName && isDocStore">
                  <span class="col-12 py-1 pl-3 " style="font-size: 14px; line-height: 32px;">
                    <a href="/docstore" style="color: black;">Hydro DocStore</a>
                  </span>
                  <hr style="background-color: white;" class="m-0">
                  <div class="lightBlue sub-item">
                    <div class="px-3 py-1">
                      <ul class="d-flex flex-column" *ngIf="!userName">
                        <li>
                          <a href="/login?redirectTo=DOCSTORE" style="color: black;">Sign-In</a>
                        </li>
                      </ul>
                      <ul class="d-flex flex-column" *ngIf="isDocStore">
                        <li *ngFor="let item of docStoreMenu" [hidden]="checkHidden(item.permissions)">
                          <a [routerLink]="item.url" class="url-item" style="color: black;">
                            {{item.name}}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row m-0">
                <div class="col-12 px-0 darkBlue portal" *ngIf="!userName || userName && isEOL || userName && isSupplierHasPermission">
                  <span class="col-12 py-1 pl-3 " style="font-size: 14px; line-height: 32px;">
                    <a href="/eol" style="color: black;">EOL Forms</a>
                  </span>
                  <hr style="background-color: white;" class="m-0">
                  <div class="lightBlue sub-item">
                    <div class="px-3 py-1">
                      <ul class="d-flex flex-column" *ngIf="!userName">
                        <li>
                          <a href="/login?redirectTo=EOL" style="color: black;">Sign-In</a>
                        </li>
                      </ul>
                      <ul class="d-flex flex-column" *ngIf="isEOL || isSupplierHasPermission">
                        <li *ngFor="let item of eolMenu" [hidden]="checkHidden(item.permissions, item)">
                          <a [routerLink]="item.url" class="url-item" style="color: black;">
                            {{item.name}}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="padding-layout-nav-top" style="min-width:120px;" *ngIf="!userName">
      </li>
      <li class="padding-layout-nav-top" style="padding-right: 40px; cursor: pointer!important;" *ngIf="!userName">
        <a href="/login" class="text-white">Sign In</a>
      </li>
      <li class="padding-layout-nav-top" *ngIf="userName" style="cursor: pointer;">
        <div class="text-white mr-2">{{userName}}&nbsp; &nbsp;({{roleName}})</div>
      </li>
      <li class="padding-layout-nav-top" style="padding-right: 40px; cursor: pointer !important;" *ngIf="userName">
        <a (click)="logOut()" class="text-white">Sign Out</a>
      </li>
    </ul>
  </div>
  <div class="row col-12 no-gutters d-none d-sm-block">
    <div class="row col-xl-5 col-md-8 col-sm-12 align-items-center" style="padding-left: 15px; margin-top: -10px;">
      <img src="../../../../assets/images/ge-vernova-logo.svg" class="ge-logo" alt="" style="cursor: pointer;"
        onclick="location.href=''">
      <div *ngIf="!isContractManagementModule" class="align-items-center align-middle pl-2 text-header-logo">
      </div>
    </div>
  </div>
  <!-- <nav *ngIf="!userName" class="row col-12 ml-auto align-items-center justify-content-end no-gutters">
        <ul class="col-xl-11 col-md-11 pl-auto text-right justify-content-end d-none d-sm-block">
            <li class="px-3 top-nav" *ngFor="let item of menuItemHomePage">
                <div class="col-12 px-3">
                    {{item.name}}
                </div>
                <ul class="dropdown text-left">
                    <li class="col-12 pt-2 pb-3 pl-1 pr-1" *ngFor="let child of item.children">
                        <a href="{{child.url}}" class="btm-line Array cool-link">
                            <span>
                                {{child.name}}
                            </span>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </nav> -->
</div>
<app-layout-header-mobile class="d-block d-sm-none px-1 pb-3" style="width: 100%;">
</app-layout-header-mobile>
<div class="col-12 no-gutters pb-2 pt-3 d-none d-sm-block">
  <app-breadcrumb></app-breadcrumb>
</div>